"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRhumb = require("react-rhumb");

var _actions = require("settings-ui-sdk/Domains/actions");

var _actions2 = require("settings-ui-sdk/SiteSettings/actions");

var _RequestStatusTypes = require("settings-ui-sdk/constants/RequestStatusTypes");

var _selectors = require("settings-ui-sdk/SiteSettings/selectors");

var _LoadingHOC = _interopRequireDefault(require("settings-ui-lib/components/hoc/LoadingHOC"));

var BasePagesSettingsContainer =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(BasePagesSettingsContainer, _Component);

  function BasePagesSettingsContainer() {
    (0, _classCallCheck2.default)(this, BasePagesSettingsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BasePagesSettingsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(BasePagesSettingsContainer, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.loadDomains();
      this.props.loadSiteSettings();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fetchSiteSettingsRequestStatus = _this$props.fetchSiteSettingsRequestStatus,
          children = _this$props.children;
      return _react.default.createElement(_LoadingHOC.default, {
        unrecoverableFailure: true,
        requestStatuses: [fetchSiteSettingsRequestStatus],
        successMarker: _react.default.createElement(_reactRhumb.NavMarker, {
          name: "SITE_SETTINGS_LOADED"
        }),
        failureMarker: _react.default.createElement(_reactRhumb.NavMarker, {
          name: "SITE_SETTINGS_LOADED_FAILURE"
        })
      }, _react.default.createElement("div", {
        className: "site-settings-page"
      }, children));
    }
  }]);
  return BasePagesSettingsContainer;
}(_react.Component);

BasePagesSettingsContainer.propTypes = {
  loadDomains: _react.PropTypes.func.isRequired,
  loadSiteSettings: _react.PropTypes.func.isRequired,
  fetchSiteSettingsRequestStatus: _RequestStatusTypes.RequestStatusPropType.isRequired,
  children: _react.PropTypes.node
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    fetchSiteSettingsRequestStatus: (0, _selectors.getFetchSiteSettingsRequestStatus)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, {
  loadDomains: _actions.loadDomains,
  loadSiteSettings: _actions2.loadSiteSettings
})(BasePagesSettingsContainer);

exports.default = _default;
module.exports = exports.default;